import { render, staticRenderFns } from "./ServeOriginal.vue?vue&type=template&id=449da6a6&scoped=true&"
import script from "./ServeOriginal.vue?vue&type=script&lang=js&"
export * from "./ServeOriginal.vue?vue&type=script&lang=js&"
import style0 from "./ServeOriginal.vue?vue&type=style&index=0&id=449da6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449da6a6",
  null
  
)

export default component.exports